<template>
  <div class="tabContainer">
    <div class="add">
			<el-button
				:icon="Plus"
				type="primary"
				@click="handleAddItem"
        size="small"
			>增加一项</el-button>
		</div>
    <el-table :data="sheetChartList" border size="small">
      <el-table-column label="选择列" prop="field">
        <template v-slot="{ row, $index }">
          <el-select
            v-if="selectArr.length"
            v-model="row.field"
            class="m-2 rule-row-item"
            placeholder="请选择数据"
            value-key="code"
            size='small'
          >
            <el-option
              v-for="item in selectArr"
              :key="item.code"
              :label="item.name"
              :value="item"
            >
              <div class="cs-drag-item bg ellipsis">
                <svg-icon
                  color="#878f95"
                  class="text m mr-4"
                  :icon-class="getIcon(item.fieldType)"
                />
                <span>{{ item.name }}</span>
              </div>
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="图表类型" prop="chartClass">
        <template v-slot="{ row, $index }">
          <el-select clearable v-model="row.chartClass" size="small">
            <el-option label="进度条" value="progress" />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="类型" prop="chartType">
        <template v-slot="{ row, $index }">
          <el-select clearable v-model="row.chartType" size="small">
            <el-option label="线形" value="line" />
            <el-option label="环形" disabled value="circle" />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="线条粗细" prop="lineWidth">
        <template v-slot="{ row, $index }">
          <el-input v-model="row.lineWidth" />
        </template>
      </el-table-column>
      <el-table-column label="显示数值" prop="showValue">
        <template v-slot="{ row, $index }">
          <el-switch v-model="row.showValue" size="small"></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="轨道颜色" prop="bgColor">
        <template v-slot="{ row, $index }">
          <div class="flex">
            <el-color-picker
              :predefine="predefineColors"
              v-model="row.bgColor"
              size="small"
            ></el-color-picker>
            <span>{{row.bgColor}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="图形颜色" prop="innerColor">
        <template v-slot="{ row, $index }">
          <div class="flex">
            <el-color-picker
              :predefine="predefineColors"
              v-model="row.innerColor"
              size="small"
            ></el-color-picker>
            <span>{{row.innerColor}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template v-slot="{ row, $index }">
          <el-link
            @click="sheetChartList.splice($index, 1)"
            :underline="false"
            type="danger"
            >删除</el-link
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script setup>
import { computed, onMounted, ref, watch } from "vue";
import { deepClone } from "@/echart/util";
import { ElMessage } from "element-plus";
import ruleFilter from "./Rule.vue";
import { Plus, Edit, Delete } from '@element-plus/icons-vue'
import { MODEL_COLUMN_TYPE, predefineColors } from "@/option/common/dict.js";

const props = defineProps({
  linkData: {
    type: Object,
    default() {
      return {};
    },
  },
  componentNape: {
    type: String,
    default: "",
  },
  modelValue: {
    type: Boolean,
  },
  option: {
    type: Object,
    default() {
      return {};
    },
  },
  sheetChartData: {
    type: Array,
    default: [],
  },
});

const selectArr = computed(() => {
  const { columns = [], groups = [], metrics = [], rows = [] } = props?.option;
  const arr = [...columns, ...metrics, ...rows];

  return arr.map((item) => {
    return item.type === "cus"
      ? {
          ...item,
          fieldType: "Number",
        }
      : item;
  });
});

let sheetChartList = ref([
  {
    field: "",
    chartClass: "progress",
    chartType: "line",
    lineWidth: "6",
    showValue: true,
    bgColor: "#E6E6E6",
    innerColor: "#FC7777",
  }
]);

const getIcon = (type) => {
  switch (type) {
    case MODEL_COLUMN_TYPE.date:
      return "date";
    case MODEL_COLUMN_TYPE.number:
      return "123";
    default:
      return "abc";
  }
}

const handleAddItem = () => {
  sheetChartList.value = [...sheetChartList.value,
    {
      field: "",
      chartClass: "progress",
      chartType: "line",
      lineWidth: "6",
      showValue: true,
      bgColor: "#E6E6E6",
      innerColor: "#FC7777",
    }
  ]
}

const clearData = () => {
  sheetChartList.value = [
    {
      field: "",
      chartClass: "progress",
      chartType: "line",
      lineWidth: "6",
      showValue: true,
      bgColor: "#E6E6E6",
      innerColor: "#FC7777",
    }
  ]
}

const submitData = () => {
  const list = deepClone(sheetChartList.value)
  let validated = true
  list.forEach((item) => {
    if (Object.values(item).find(val => val === '' || val === undefined)) {
      validated = false
    }
  })
  if (list.length && validated) {
    return list
  } else {
    ElMessage.error('所有字段必填, 请检查表单')
  }   
}

defineExpose({
  clearData,
  submitData,
});

onMounted(() => {
  if (props.option?.sheetChartData && props.option?.sheetChartData.length) {
    sheetChartList.value = deepClone(props.option?.sheetChartData)
  }
})
</script>

<style lang="scss" scoped>
.tabContainer {
  width: 100%;
  max-height: 500px;
  overflow-y: auto;
  .add {
    margin-bottom: 16px;
  }
}
</style>
